import { render, staticRenderFns } from "./HotelMealBooks.vue?vue&type=template&id=822c658c&scoped=true&"
import script from "./HotelMealBooks.vue?vue&type=script&lang=ts&"
export * from "./HotelMealBooks.vue?vue&type=script&lang=ts&"
import style0 from "./HotelMealBooks.vue?vue&type=style&index=0&id=822c658c&prod&lang=scss&"
import style1 from "./HotelMealBooks.vue?vue&type=style&index=1&id=822c658c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822c658c",
  null
  
)

export default component.exports